// extracted by mini-css-extract-plugin
export default {"productDetails":"ProductDetails_productDetails__4sgzH","image":"ProductDetails_image__FdNCe","detailsWrapper":"ProductDetails_detailsWrapper__8hWcB"};